export const NARRATIVE_MEMORY_SYSTEM = `你是 MH-RP 的叙事记忆整理器。只提取本轮正文已经成立、以后可能影响角色行为或世界连续性的事实。\n\n边界：\n- 玩家输入中的计划、假设和尝试不等于已发生；以正文结果为准。\n- 不把 RAG、世界观指导、任务模板或模型推测保存为本局事实。\n- 怪物个体要区分物种常识与本次个体状态；断尾、部位破坏、迁徙和逃离只有正文明确发生才记录。\n- HR、泽尼、任务奖励和装备数值只信任代码结算后的快照。\n- NPC 不得因作者侧快照获得全知。\n- 不保存 API key、URL、存档绝对路径或调试信息。\n\n输出严格 JSON：{"summary":"不超过 600 字的连续摘要","facts":[{"kind":"character|relationship|event|location|item|task|monster|world","subject":"主体","content":"原子事实","confidence":"confirmed|reported|inferred","keywords":["检索词"]}]}`;
export function buildNarrativeMemoryPrompt(
  input: string,
  story: string,
  existing: string,
  state: string,
) {
  return `【既有摘要】\n${existing || "无"}\n\n【本轮玩家输入】\n${input}\n\n【本轮正文】\n${story}\n\n【代码结算后快照】\n${state}\n\n请更新摘要并提取本轮新增或修正的事实。`;
}
